import { $cms } from "@/utils/api";

export function getTalentPools(params) {
    return $cms().get(`/manage/talent_pools`, { params });
}

export function getTalentPool(id) {
    return $cms().get(`/manage/talent_pools/${id}`);
}

export function remarkTalentPool(id, data) {
    return $cms().put(`/manage/talent_pools/${id}`, data);
}

export function updateTalentPoolStatus(id, data) {
    return $cms().put(`/manage/talent_pools/${id}/status`, data);
}

export function getTalentPoolStat(params) {
    return $cms().get(`/manage/talent_pools/unread/count`, { params });
}
